import { useQuery } from "@tanstack/react-query";

import { AlertError, ContentSingleColumn, TipaltiIframe } from "~components";
import { GET, translate } from "~utils";

import { ScorePage } from "../../ScoreTemplates";

export function MyEarnings() {
  const { data: tipaltiPaymentData, isLoading: isTipaltiLoading } = useQuery({
    queryKey: ["fetchPayment"],
    queryFn: () => GET("/api/sub/me/payment"),
    throwOnError: true, // flag necessary for uncaught errors to bubble to App level ErrorBoundary
    refetchOnWindowFocus: false, // avoid iframe content being re-loaded
  });

  return (
    <ScorePage
      title={translate("PAGE_TITLE_PAYMENT_MY_EARNINGS")}
      hasBack
      isLoading={isTipaltiLoading}
    >
      <ContentSingleColumn>
        <div style={{ width: "100%", padding: "24px 16px" }}>
          {tipaltiPaymentData?.data.paymentHistoryUrl ? (
            <TipaltiIframe
              title={translate("PAGE_TITLE_PAYMENT_MY_EARNINGS")}
              tipaltiUrl={tipaltiPaymentData?.data.paymentHistoryUrl}
            />
          ) : (
            <AlertError />
          )}
        </div>
      </ContentSingleColumn>
    </ScorePage>
  );
}
